import React, { useState, useEffect } from "react";

import {
  TextField,
  Alert,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import { Update, Delete } from "@mui/icons-material";
import Select from "react-select";
import apiUrl from "../api";

import axios from "axios";

const DeleteDialog = (props) => {
  const handleVendorDelete = async (e) => {
    e.preventDefault();
    props.setError("");
    props.setSuccess("");

    // Add your API call here to delete the vendor
    try {
      await axios.delete(`${apiUrl}/vendor/${props.selectedVendor}`, {
        headers: {
          Authorization: `Bearer ${props.user.token}`,
        },
      });

      props.setVendors(
        props.vendors.filter((vendor) => vendor._id !== props.selectedVendor)
      );

      props.setSuccess("Vendor deleted successfully.");
      props.onClose();
    } catch (error) {
      console.log(error);
      props.setError("Failed to delete vendor. Please try again.");
      props.onClose();
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Vendor"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this vendor? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button onClick={handleVendorDelete} autoFocus color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const UpdateVendor = () => {
  const [vendorName, setVendorName] = useState("");
  const [vendorPhone, setVendorPhone] = useState("");
  const [vendorTaxId, setVendorTaxId] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get(`${apiUrl}/vendor/`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setVendors(response.data.vendors);
      } catch (error) {
        setError("Failed to fetch vendors. Please try again.");
      }
    };
    fetchVendors();
  }, [user.token]);

  const handleVendorSelect = (selectedOption) => {
    const vendor = vendors.find((v) => v._id === selectedOption.value);
    setSelectedVendor(selectedOption.value);
    setVendorName(vendor.name);
    setVendorPhone(vendor.phone || "");
    setVendorTaxId(vendor.tax_id || "");
  };

  const handleUpdateVendor = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (vendorName === "") {
      return setError("Vendor name is required.");
    }

    // Add your API call here to update the vendor
    try {
      await axios.put(
        `${apiUrl}/vendor/${selectedVendor}`,
        {
          name: vendorName,
          phone: vendorPhone,
          tax_id: vendorTaxId,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setVendors(
        [...vendors].map((vendor) => {
          if (vendor._id === selectedVendor) {
            return {
              ...vendor,
              name: vendorName,
              phone: vendorPhone,
              tax_id: vendorTaxId,
            };
          }
          return vendor;
        })
      );

      setSuccess("Vendor updated successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Vendor with this Tax ID already exists.");
      } else {
        setError("Failed to update Vendor. Please try again.");
      }
    }
  };

  return (
    <div className="update-category-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "10px",
          fontWeight: "600",
        }}
      >
        Edit Vendor
      </h4>
      <Select
        value={selectedVendor.value}
        onChange={(selectedOption) => handleVendorSelect(selectedOption)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "var(--secondary-color)",
            primary25: "var(--tertiary-color)",
          },
        })}
        options={[
          ...vendors.map((vendor) => ({
            value: vendor._id,
            label: `${vendor.name} ${vendor.tax_id ? `(${vendor.tax_id})` : ""}`,
          })),
        ]}
        styles={{
          menu: (base) => ({
            ...base,
            zIndex: 1000,
          }),
        }}
        placeholder="Select a vendor to edit..."
      />

      {selectedVendor && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <form
            onSubmit={handleUpdateVendor}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                width: "100%",
                alignItems: "center",
              }}
            >
              <TextField
                variant="outlined"
                label="Vendor Name"
                placeholder="Vendor Name"
                value={vendorName}
                onChange={(e) => setVendorName(e.target.value)}
                fullWidth
                margin="normal"
                InputProps={{
                  inputProps: { style: { height: "56px", padding: "5px" } },
                }}
              />
              <TextField
                variant="outlined"
                label="Phone Number"
                placeholder="Phone Number"
                value={vendorPhone}
                onChange={(e) => setVendorPhone(e.target.value)}
                fullWidth
                margin="normal"
                InputProps={{
                  inputProps: { style: { height: "56px", padding: "5px" } },
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                width: "100%",
                alignItems: "center",
              }}
            >
              <TextField
                variant="outlined"
                label="Tax ID"
                placeholder="Tax ID"
                value={vendorTaxId}
                onChange={(e) => setVendorTaxId(e.target.value)}
                fullWidth
                margin="normal"
                InputProps={{
                  inputProps: { style: { height: "56px", padding: "5px" } },
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <button
                  className="add-ticket-button__button"
                  sx={{
                    backgroundColor: "var(--primary-color)",
                    color: "var(--primary-text-color)",
                    fontSize: "15px",
                    fontWeight: "600",
                    width: "auto",
                    padding: "10px 20px",
                  }}
                  onClick={() => {}}
                >
                  <Update />
                  <span>Update</span>
                </button>
                <button
                  className="add-ticket-button__button"
                  sx={{
                    backgroundColor: "var(--primary-color)",
                    color: "var(--primary-text-color)",
                    fontSize: "15px",
                    fontWeight: "600",
                    width: "auto",
                    padding: "0px 20px",
                  }}
                  onClick={() => setDeleteDialogOpen(true)}
                  type="button"
                >
                  <Delete />
                  <span>Delete</span>
                </button>
              </div>
            </div>
          </form>
          <DeleteDialog
            open={deleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            vendors={vendors}
            setVendors={setVendors}
            selectedVendor={selectedVendor}
            setError={setError}
            setSuccess={setSuccess}
            user={user}
          />
        </div>
      )}
    </div>
  );
};

export default UpdateVendor;
